export default (col, field) => {
    return col.map((c) => field ? c[field] : c.ID);
}
